import './PitcherSingleSessionPitchTypeRangesChart.scss';

import {
  PitcherSingleSessionPitchTypeRangesChartConfigDto,
  PitcherSingleSessionPitchTypeRangesChartDataDto,
} from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/PitcherSingle/reportStore';
import PitchTypeRanges from 'components/PitchTypeRanges/PitchTypeRanges';

const PitcherSingleSessionPitchTypeRangesChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<PitcherSingleSessionPitchTypeRangesChartDataDto, PitcherSingleSessionPitchTypeRangesChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PitcherSingleSessionPitchTypeRangesChart-container'>
      <PitchTypeRanges
        pitchTypeRanges={chartData?.pitchTypeRanges}
        isLoading={isLoading}
        selectedMeasurementOption={extraChartData.selectedMeasurementOption}
        seePitchesBy={selectedConfgValues.pitchGrouping}
      />
    </div>
  );
};

export default PitcherSingleSessionPitchTypeRangesChart;
